import { Waves } from "lucide-react";

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return <div className={`brand-mark ${compact ? "compact" : ""}`} aria-label="MOLA Course Board">
    <span className="brand-symbol"><Waves /></span>
    <span className="brand-words"><strong>MOLA</strong><small>COURSE BOARD</small></span>
  </div>;
}
